export const ENGAGEMENT_REQUIREMENTS_ROOT_PATH =
  "/member/engagement-requirements";

export const ENGAGEMENT_REQUIREMENTS_CREATE_BY_TEMPLATE_SELECT_PATH = `${ENGAGEMENT_REQUIREMENTS_ROOT_PATH}/create-by-template/:tabId`;
export const ENGAGEMENT_REQUIREMENTS_CREATE_BY_TEMPLATE_FLOW_PATH = `${ENGAGEMENT_REQUIREMENTS_ROOT_PATH}/creation/:templateId`;

export const ENGAGEMENT_REQUIREMENTS_DETAILS_PATH = `${ENGAGEMENT_REQUIREMENTS_ROOT_PATH}/:requirementId`;

export const ENGAGEMENT_REQUIREMENTS_TAB_SLUGS = [
  "active",
  "archived"
] as const;
export const ENGAGEMENT_REQUIREMENTS_CREATION_TAB_SLUGS = [
  "all",
  "standard",
  "smart"
] as const;

export const ENGAGEMENT_REQUIREMENTS_SECTION_PATHS =
  ENGAGEMENT_REQUIREMENTS_TAB_SLUGS.map(
    tabSlug => `${ENGAGEMENT_REQUIREMENTS_ROOT_PATH}/${tabSlug}`
  );

export type RequirementsDefinitionsDashboardTabSlug =
  (typeof ENGAGEMENT_REQUIREMENTS_TAB_SLUGS)[number];
export type CreateRequirementTabSlug =
  (typeof ENGAGEMENT_REQUIREMENTS_CREATION_TAB_SLUGS)[number];
